import { useId } from 'react';
import { useRegisterModal } from '@/contexts/layout';

const CMODAL_REGISTRATION_ID = 'cmodal';

interface UseCmodalRegistrationInput {
  visible: boolean;
  onClose?: () => void;
}

type CmodalCloseHandler = () => void;

export function useCmodalRegistration({
  visible,
  onClose,
}: UseCmodalRegistrationInput): CmodalCloseHandler {
  const modalRegistrationId = useId();

  const handleClose = (): void => {
    if (onClose) {
      onClose();
    }
  };

  // Cmodal renders inline and keeps its own Cblurbackdrop + z-index, so it
  // registers with backdrop:null. The shared provider backdrop lives in the
  // portal layer and must not render behind this inline modal.
  useRegisterModal({
    id: `${CMODAL_REGISTRATION_ID}-${modalRegistrationId}`,
    visible: visible && Boolean(onClose),
    onClose: handleClose,
    backdrop: null,
  });

  return handleClose;
}
